import React from "react";

interface HpFrontDeskIconProps {
  width?: number;
  height?: number;
  className?: string;
  showBadge?: boolean;
}

/**
 * HP header FrontDesk (envelope) icon.
 * Same 24×24 canvas + corner badge as HpNotificationsIcon so both header
 * icons share size and red-dot placement. Envelope paths are nudged down
 * slightly so the glyph optically aligns with the bell.
 */
export const HpFrontDeskIcon: React.FC<HpFrontDeskIconProps> = ({
  width = 24,
  height = 24,
  className,
  showBadge = false,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: "block" }}
    >
      <g transform="translate(0, 1.5)">
        <path
          d="M20.5 7.25L13.09 11.9C12.78 12.09 12.4 12.19 12.01 12.19C11.62 12.19 11.24 12.09 10.93 11.9L3.5 7.25"
          stroke="#A3A3A3"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5 4.75H4.5C3.53 4.75 2.75 5.53 2.75 6.5V16.5C2.75 17.47 3.53 18.25 4.5 18.25H19.5C20.47 18.25 21.25 17.47 21.25 16.5V6.5C21.25 5.53 20.47 4.75 19.5 4.75Z"
          stroke="#A3A3A3"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      {showBadge && (
        <path
          d="M16 4C16 1.79086 17.7909 0 20 0C22.2091 0 24 1.79086 24 4C24 6.20914 22.2091 8 20 8C17.7909 8 16 6.20914 16 4Z"
          fill="#CC2C00"
        />
      )}
    </svg>
  );
};
